    import { useState, useContext, useEffect } from 'react';
    import { ButtonGroup, StandardButton } from '../atoms/buttons';
    import { HorizontalLayout } from './layout';
    import { PageContext, UserContext } from '../App';
    import { Badge } from '../atoms/badges';
    import { icon } from '../functions/icons';
    import { DropdownButton } from '../atoms/buttons';
    import { eventWrapper } from '@testing-library/user-event/dist/utils';
import { IconAtom } from "../atoms/iconAtom";
import { position } from "polished";
import CardInfo from "./tap-to-learn/CardInfo";
import { TextAtom } from "../atoms/TextAtom";
import { PagePagination } from "../molecule/PagePagination";

export function EmployeesList({ employees, pagelimit = 8, deleteEmployee, setEditEmployee,showDepartments, onEmployeeClick }) {
        const navigationContext = useContext(PageContext);
        const userContext = useContext(UserContext)
        const isPublic = userContext.account_type === 1
        const [currentPage, setCurrentPage] = useState(0);
        const [windowWidth, setWindowWidth] = useState(window.innerWidth);
        const [openDropdownId, setOpenDropdownId] = useState(null);
        const startIdx = currentPage * pagelimit;
        const currentEmployees = employees.slice(startIdx, startIdx + pagelimit);
        const totalPages = Math.ceil(employees.length / pagelimit);
        function windowSize(){
            const handleResize = () => {
                setWindowWidth(window.innerWidth);
              };
              window.addEventListener('resize', handleResize);
              return () => window.removeEventListener('resize', handleResize);
        }

        function removeEmployee(eventOrId, id, name, stopPropagation = true) {
            if (stopPropagation && eventOrId?.stopPropagation) {
                eventOrId.stopPropagation(); 
            }
            deleteEmployee(id, name);
        }
        function editDepartments(eventOrId, id, stopPropagation = true) {
            if (stopPropagation && eventOrId?.stopPropagation) {
                eventOrId.stopPropagation(); 
            }
            showDepartments(id);
        }
        function editEmployee(eventOrId, id, stopPropagation = true) {
            if (stopPropagation && eventOrId?.stopPropagation) {
                eventOrId.stopPropagation(); 
            }
            setEditEmployee(id);
        }
        function viewEmployee(id) {
             if (isPublic) {
                navigationContext.handleNavigation({ navigation: 16, cardInfo:{id_card: id.id_card, lead: id, uuid_card:id.uuid_card }});
            } else {
                navigationContext.handleNavigation({ navigation: 6, userId: id });
            }
        }
        useEffect(() => {
            setCurrentPage(0); 
        }, [employees]);

        useEffect(() => {
            if (currentPage > 0 && currentPage >= Math.ceil(employees.length / pagelimit)) {
                setCurrentPage(currentPage - 1); 
            }
        }, [employees]);
        
        function optionSelected(actionId, employee) {
            const id = isPublic ? employee.id_lead : employee.id_users
            switch (actionId) {
                case "edit01":
                    editEmployee(null, id, false);
                    break;
                case "departments":
                    editDepartments(null, id, false);
                    break;
                case "remove01":
                    removeEmployee(null, id, `${employee.first_name} ${employee.last_name}`, false);
                    break;
                default:
                    console.log("No action defined for this option.");
                    break;
            }
        }
        function getClampedClass(openDropdownId, employeeId, windowWidth) {
            const isActive = openDropdownId === employeeId;
            const isInactive = openDropdownId !== employeeId;
          
            if (isActive && windowWidth <= 350) {
              return 'clamped-text';
            } else if (isInactive && windowWidth <= 310) {
              return 'clamped-text disabled';
            }
            return '';
          }
        useEffect(() => {
        }, [openDropdownId]);

        useEffect(() => {
            windowSize();
        }, []);
        const isMobile = windowWidth < 768;
        return (
            <>

                <div className="employee-list standard-comp standard-margin-top" style={{ height: "auto", minHeight: "32.125rem", marginRight: "0"}}>
                    { currentEmployees.map((employee) => {
                        var avatarSrc = employee.avatar_url ? employee.avatar_url : `https://ui-avatars.com/api/?name=${employee.id_card && !employee.id_lead ? "" : `${employee.first_name} ${employee.last_name}`}&background=random&color=fff&format=svg`;
                        const id = isPublic ? employee.id_lead : employee.id_users
                        console.log(employee);
                        return (
                            <div className={`employee-comp ${isPublic ? employee.id_card ? "" : "no-click" : ""}`} onClick={() => { if (!(isPublic && !employee.id_card)) {viewEmployee(employee.id_card ? employee : id);} }} >
                                <div>
                                    <img className="rounded-img" src={avatarSrc} alt={`${employee.first_name} ${employee.last_name} profile avatar`}/>
                                </div>
                                <div style={{flexGrow: 1}}>
                                    <p className={`employee-name ${getClampedClass(openDropdownId, id, windowWidth)}`} style={{"display": "flex", gap: "0.5rem"}}>{employee.id_card && !employee.id_lead ? "Geen eigenaar" : `${employee.first_name || ""} ${employee.last_name || ""}` } {isPublic && (<span className="public-badge relative">{icon(employee.id_card ? "card": "extern",22,"var(--primary-500)")}<div style={{ position: "absolute", top: "-.5rem", right: "-.5rem", }}>{icon("status", 12, (employee.id_card ? (employee.status===1 && employee.active===1) : (employee.active === 1)) ? "var(--success-500)" : "var(--grey-400)")}</div></span>)}</p>
                                    <p  className={`employee-email ${getClampedClass(openDropdownId, id, windowWidth)}`}>{ employee.email }</p>
                                </div>
                                <div className="employee-actions" style={{"textAlign": "right", "position":"relative"}}>
                                {isMobile ? ( userContext.permissions.includes("users.manage") && (employee.id_lead || employee.id_users) &&  (
                                    <div onClick={(e) => e.stopPropagation()}> 
                                        <DropdownButton
                                            content={ <>{icon("dots-vertical")}</>} 
                                            optionSelected={(id) => {
                                            optionSelected(id, employee);
                                            }}
                                            onToggle={(isOpen) => setOpenDropdownId(isOpen ? id : null)}
                                            isOpen={openDropdownId === id}
                                            dropdown={[
                                            { id: "edit01", content: <>{icon("edit")}</> },
                                            { id: "departments", content: <>{icon("users")}</> },
                                            { id: "remove01", content: <>{icon("trash")}</> },
                                            ]}
                                            classButton={"phone-dropdown"}
                                            classContent={"phone-dropdown-menu"}
                                        />
                                        </div>
                                    )
                                    ) : (
                                    userContext.permissions.includes("users.manage") && (employee.id_lead || employee.id_users) && (
                                        <ButtonGroup
                                        buttons={[{id: "edit01",onClick: (e) => editEmployee(e, id),content: <>{icon("edit")}</>,},{id: "departments",onClick: (e) => editDepartments(e, id),content: <>{icon("users")}</>,},{id: "remove01",onClick: (e) =>removeEmployee(e, id, `${employee.first_name} ${employee.last_name}`),content: <>{icon("trash")}</>,},]}
                                        />
                                    )
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <PagePagination onPageChange={setCurrentPage} currentPage={currentPage} totalPages={totalPages} totalUnits={employees.length} unitName="leads"  />
            </>
        )
    }

